import ENV from './Env.js';


 

export const getList = () => {
  return fetch(`${ENV.API_URL}/menu/all`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json()
  });
}


export const makeMenu = (_api, _data) => {
  _data['api_token'] = _api;

  return fetch(ENV.API_URL + '/menu/store', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}


export const updateMenu= (_api, _data) => {
  _data['api_token'] = _api;

  return fetch(`${ENV.API_URL}/menu/update/${_data['id']}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}

 